import { mapActions, mapGetters } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import widgetEmptyState from '@/components/generics/widget-empty-state/widget-empty-state';
import applySortOrder from '@/components/pinning/pinboard-sort';
import pinboardWidgetItem from '@/components/pinning/pinboard-widget-item/pinboard-widget-item.vue';
import pinboardWidgetSkeleton from '@/components/pinning/pinboard-widget-skeleton/pinboard-widget-skeleton.vue';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';

export default {
  mixins: [loaderMixin],
  components: {
    pinboardWidgetItem,
    widgetEmptyState,
    pinboardWidgetSkeleton,
  },
  computed: {
    ...mapGetters('widgets', ['getWidget']),
    ...mapGetters('pinning', ['getWidgetSort']),
    ...mapGetters('user', ['isLoggedIn']),
    listItems() {
      const sort = this.getWidgetSort('biggest-losses');
      const items = (this.getWidget('biggest-losses').data || []).map((promo) => {
        const contract = new Contract(promo);
        return {
          contractId: promo.contractId,
          marketId: promo.marketId,
          marketName: promo.marketName,
          contractName: promo.contractName,
          price: contract.changePriceAsCents,
          priceAsCents: contract.lastTradePriceAsCents,
          hasLastTradePrice: contract.hasLastTradePrice,
          lastClosePrice: contract.lastClosePrice,
          tradeVolume: contract.totalSharesTradedNumber,
          investmentSize: contract.investmentSizeAsCents,
        };
      });
      return applySortOrder(items, sort, 'biggest-losses');
    },
  },
  methods: {
    ...mapActions('widgets', ['fetchBiggestLoss']),
    ...mapActions('popup', ['setCurrentPopup']),
    onLogin() {
      this.setCurrentPopup(MODALS.LOGIN);
    },
    loadData() {
      if (this.getWidget('biggest-losses').data !== null) return;
      this.loaderAdd();
      this.fetchBiggestLoss().then(() => this.loaderRemove());
    },
  },
  watch: {
    isLoggedIn(val) {
      if (val) this.loadData();
    },
  },
  mounted() {
    if (!this.isLoggedIn) return;
    this.loadData();
  },
};
